import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminUsersListPage from './AdminUsersListPage';

export default function AdminRoutes() {
  return (
    <Routes>
      <Route index element={<AdminUsersListPage />} />
      <Route path="users" element={<AdminUsersListPage />} />
      <Route path="leaves" element={<Navigate to="/admin/leaves" replace />} />
      <Route path="leave-manager" element={<Navigate to="/admin/leaves" replace />} />
      <Route path="leave-management" element={<Navigate to="/admin/leaves" replace />} />
    </Routes>
  );
}
